import { http } from '.';
import { CurrentSubscriptionResponse } from './fetchCurrentSubscription';

export interface FetchUserSubscriptionRequest {
  username?: string;
  email?: string;
}

export interface FetchUserSubscriptionResponse extends CurrentSubscriptionResponse {}

export async function fetchUserSubscription({
  username,
  email,
}: FetchUserSubscriptionRequest): Promise<FetchUserSubscriptionResponse> {
  console.log("📡 [Backend Call] Fetching user subscription:", {
    username,
    email,
  });

  const params: any = {};
  
  if (username) {
    params.username = username;
  }
  if (email) {
    params.email = email;
  }

  const response = await http.get<FetchUserSubscriptionResponse>(
    '/subscriptions/user_current/',
    { params }
  );

  console.log("📡 [Backend Response] User subscription response:", response);
  return response;
}

